export default __webpack_public_path__ + "static/media/logo-stb.a586e2a9.png";